module.exports = __webpack_public_path__ + "static/img/iconshengyin_guanbi_24_hei.bd82b84a.png";